<template>
    <div class="cookie-policy">
        <h1>นโยบายคุกกี้ (Cookie Policy)</h1>
        <p>วันที่มีผลบังคับใช้: <strong>[วันที่]</strong></p>

        <section>
            <h2>1. คุกกี้คืออะไร?</h2>
            <p>
                คุกกี้คือไฟล์ข้อความขนาดเล็กที่ถูกจัดเก็บไว้ในอุปกรณ์ของคุณเมื่อคุณเข้าชมเว็บไซต์
                คุกกี้จะช่วยให้เว็บไซต์จดจำข้อมูลเกี่ยวกับการเข้าชมของคุณ เช่น ภาษาโปรด ข้อมูลการเข้าสู่ระบบ และการตั้งค่าอื่น ๆ
                เพื่อปรับปรุงประสบการณ์การใช้งานของคุณในการเข้าชมครั้งต่อไป
            </p>
        </section>

        <section>
            <h2>2. คุกกี้ประเภทที่เราใช้</h2>
            <ul>
                <li>
                    <strong>คุกกี้ที่จำเป็น (Strictly Necessary Cookies):</strong>
                    คุกกี้เหล่านี้มีความสำคัญต่อการทำงานของเว็บไซต์และไม่สามารถปิดการใช้งานได้ในระบบของเรา
                </li>
                <li>
                    <strong>คุกกี้เพื่อการวิเคราะห์ (Analytical Cookies):</strong> คุกกี้เหล่านี้ช่วยให้เราเข้าใจพฤติกรรมการใช้งานของผู้ใช้ในเว็บไซต์
                    เช่น การติดตามหน้าที่มีผู้เข้าชมบ่อยที่สุด
                </li>
                <li>
                    <strong>คุกกี้การทำงาน (Functionality Cookies):</strong> คุกกี้เหล่านี้ช่วยให้เว็บไซต์สามารถจดจำการตั้งค่าและตัวเลือกที่คุณทำไว้
                    เช่น ชื่อผู้ใช้ ภาษาที่คุณเลือก
                </li>
                <li>
                    <strong>คุกกี้การตลาด (Marketing Cookies):</strong> คุกกี้เหล่านี้ใช้เพื่อนำเสนอเนื้อหาที่เกี่ยวข้องกับคุณมากขึ้น
                    โดยติดตามกิจกรรมการเข้าชมเว็บไซต์ของคุณ
                </li>
            </ul>
        </section>

        <section>
            <h2>3. การจัดการคุกกี้ของคุณ</h2>
            <p>
                คุณสามารถควบคุมการตั้งค่าคุกกี้ได้โดยการปรับแต่งการตั้งค่าในเบราว์เซอร์ของคุณเพื่อปฏิเสธการตั้งค่าคุกกี้ทั้งหมดหรือบางส่วน
                โปรดทราบว่าการปิดใช้งานคุกกี้อาจส่งผลกระทบต่อการทำงานบางส่วนของเว็บไซต์
            </p>
        </section>

        <section>
            <h2>4. การเปลี่ยนแปลงนโยบายคุกกี้</h2>
            <p>
                เราอาจปรับปรุงนโยบายคุกกี้นี้ตามความเหมาะสมเพื่อให้สอดคล้องกับการเปลี่ยนแปลงในเทคโนโลยีหรือกฎหมาย คำแนะนำและการเปลี่ยนแปลงต่าง ๆ
                จะถูกประกาศในหน้าเว็บไซต์นี้
            </p>
        </section>

        <section>
            <h2>5. ติดต่อเรา</h2>
            <p>หากคุณมีคำถามหรือข้อสงสัยเกี่ยวกับนโยบายคุกกี้นี้ กรุณาติดต่อเราที่:</p>
            <ul>
                <li>อีเมล: [อีเมลของคุณ]</li>
                <li>โทรศัพท์: [เบอร์โทรของคุณ]</li>
                <li>ที่อยู่: [ที่อยู่ของคุณ]</li>
            </ul>
        </section>
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
.cookie-policy {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    font-family: Arial, sans-serif;
    color: #333;
}

.cookie-policy h1 {
    font-size: 2em;
    margin-bottom: 20px;
    color: #4caf50;
}

.cookie-policy h2 {
    font-size: 1.5em;
    margin-top: 20px;
    color: #333;
}

.cookie-policy p {
    line-height: 1.6;
    margin-bottom: 15px;
}

.cookie-policy ul {
    list-style-type: disc;
    margin-left: 20px;
    margin-bottom: 15px;
}

.cookie-policy ul li {
    margin-bottom: 10px;
}

.cookie-policy strong {
    color: #4caf50;
}
</style>
